export default __webpack_public_path__ + "static/media/4.7f0f8611.svg";